angular.module('wbDashboard').controller('FundingActivityControllerAurea',
    ['$scope', '$state', '$filter', '$timeout', 'User',
function ($scope, $state, $filter, $timeout, User) {

    $scope.pageData = {
        showFilters: false,
        loadingResults: true,
        showHistoricalActivity: false
    };

    $scope.filters = {
        data: {
            date: {},
            milestones: false,
            accounts: false,
            type: null,
        },
        page: {
            current: 1,
            max: 25
        }
    };

    $scope.pagination = {
        local: false,
        current: 0,
        pageLinkCount: 7,
        page_max: $scope.filters.page.max,
        total: 0,
        data: {}
    };

    $scope.completeActivity = [];

    $scope.pendingActivity = [];

    $scope.Object = Object;


    User.clearActivity();


    /**********************************
     * 
     * Data
     * 
     **********************************/
    $scope.$watch(function() { return User.getActivityPending(); }, function(activity) {
        if (activity && activity.length) {
            $scope.pendingActivity = User.groupActivityByDate(activity);
        }
    });
    $scope.$watch(function() { return User.getActivity(getFilterData($scope.filters)); }, function(activity) {
        if (activity) {
            $scope.completeActivity = activity.logs;

            if (!$scope.pagination.local) {
                // remote pagination
                $scope.pagination.total = activity.total;
                $scope.pagination.data = User.groupActivityByDate(activity.logs);
            } else {
                //local pagination
                $scope.pagination.total = activity.logs.length;
                $scope.pagination.current = null; //will trigger pagination
            }


        }
    });
    /**
     * For Local Pagination
     */
    if ($scope.pagination.local) {
        $scope.$watch('pagination.current + "" + pagination.page_max', function () {
            var pageActivity, pageActivityGrouped;

            if (!$scope.pagination.current) {
                //will trigger this again
                $scope.pagination.current = 1;
                return;
            }

            var current = $scope.pagination.current;
            var begin = (current - 1) * $scope.pagination.page_max;
            var end = begin + $scope.pagination.page_max;
            pageActivity = $scope.completeActivity.slice(begin, end);
            pageActivityGrouped = User.groupActivityByDate(pageActivity);
            $scope.pagination.data = pageActivityGrouped;

            angular.element("html, body").finish().animate({scrollTop: 0}, 200);
        });
    }


    /**********************************
     * 
     * Filtering
     * 
     **********************************/
    $scope.$watch('filters', function(filters, prev) {
        if (filters && filters.data.milestones && filters.data.accounts) {

            $scope.pageData.hidePending = true;

            if (prev && ( !angular.equals(filters.data, prev.data) || filters.page.max !== prev.page.max)) {
                if (filters.page.current !== 1) {
                    filters.page.current = 1;
                    return;
                }
            }

            var filterData = getFilterData(filters);
            $scope.pageData.loadingResults = true;
            User.retrieveActivity(filterData).finally(function() {
                $scope.pageData.loadingResults = false;
                if (!$scope.pagination.local) {
                    angular.element("html, body").finish().animate({scrollTop: 0}, 200);
                }
            });
        }
    }, true);
    function getFilterData(filters) {
        var filterData = {
            "milestone_id": [],
            "account_number": [],
            "min_date": null,
            "max_date": null,
            "type": null,
            "query": null,
        };

        if (!$scope.pagination.local) {
            filterData.page_start = (filters.page.current - 1) * filters.page.max;
            filterData.page_max = filters.page.max;
            $scope.pagination.page_max = filters.page.max;
        }

        if (filters.data.query) {
            filterData.query = filters.data.query;
        }

        angular.forEach(filters.data.milestones, function(selected, key) {
            if (selected) {
                filterData.milestone_id.push(key);
            }
        });
        angular.forEach(filters.data.accounts, function(selected, key) {
            if (selected) {
                filterData.account_number.push(key);
            }
        });

        if (filters.data.type) {
            filterData.type = filters.data.type;
        }

        if (filters.data.date && filters.data.date.startDate && filters.data.date.endDate) {
            filterData.min_date = filters.data.date.startDate.clone().utc().format('YYYY-MM-DD');
            filterData.max_date = filters.data.date.endDate.clone().utc().format('YYYY-MM-DD');
        }


        return filterData;
    }


    $scope.filterTypes = [
        {name:"Cash Transactions", key:"cash_transaction"},
        {name:"Auto-Deposits", key:"cash_transaction:deposit:auto"},
        {name:"Deposits", key:"cash_transaction:deposit"},
        {name:"Withdrawals", key:"cash_transaction:withdrawal"},
        {name:"Transfers", key:"transfer_transaction"},
        {name:"Trading", key:"trade:portfolio_rebalancing"},
        {name:"Formulas", key:"formula"},
        {name:"Packages", key:"package"},
        {name:"Feature", key:"feature"},
        {name:"Milestones", key:"milestone"},
        {name:"MS Create/Delete", key:"milestone:null"},
        {name:"WiseHarvesting", key:"trade:wiseharvesting"},
        {name:"Dividends", key:"trade:dividends"},
        {name:"Security", key:"security"},
        {name:"Billing", key:"billing"},
    ];

    var currentDate = moment().endOf('day').startOf('second');
    $scope.picker = {
        init: false,
        date: {startDate: null, endDate: null},
        options: {
            pickerClasses: '',
            applyButtonClasses: 'btn-primary',
            cancelButtonClasses: 'btn-outline-primary',
            alwaysShowCalendars: true,
            linkedCalendars: false,
            showDropdowns: true,
            locale: {
                format: "MM-DD-YYYY", //will give you 2017-01-06
                applyLabel: "Filter",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom',
                daysOfWeek: ["S", "M", "T", "W", "T", "F", "S"],
            },
            minDate: null,
            maxDate: null,
            ranges: {
                'Last Week': [currentDate.clone().subtract(1, 'week').startOf('day'), currentDate],
                'Last Month': [currentDate.clone().subtract(1, 'month').startOf('day'), currentDate],
                'Last 6 Months': [currentDate.clone().subtract(6, 'months').startOf('day'), currentDate],
                'Last Year': [currentDate.clone().subtract(1, 'year').startOf('day'), currentDate],
                'All Time': [null, null],
            }
        }
    };

    $scope.initPicker = function(min, max, fresh = false) {
        var currentDate = moment().endOf('day').startOf('second');
        var lastMonth = moment(currentDate).subtract(1, 'month');
        var minDate = moment(min).startOf('day');
        var ranges = $scope.picker.options.ranges;

        $scope.picker.options.minDate = minDate;
        $scope.picker.options.maxDate = currentDate;

        $scope.filters.data.date.startDate = (minDate < lastMonth) ? lastMonth : minDate;
        $scope.filters.data.date.endDate = currentDate;

        ranges['All Time'] = [minDate, currentDate];

        ['Last Month', 'Last 6 Months', 'Last Year'].forEach(function(key) {
            if (ranges[key] && minDate > ranges[key][0]) {
                delete ranges[key];
            }
        });

        if (fresh) {
            $scope.picker.init = true;
        }
    };

    $scope.$watch(function() { return User.getOverview(); }, function(overview) {
        if (overview) {

            $scope.closed = overview.user.is_closed;

            $scope.initPicker(moment.utc(overview.user.created_at).local(), moment(), false);

            $scope.accounts = overview.account_overview;

            if (!$scope.filters.data.accounts) $scope.filters.data.accounts = {};
            angular.forEach($scope.accounts, function(a) {
                $scope.filters.data.accounts[a.account_number] = false;
            });

            if (moment.utc(overview.user.created_at) < moment.utc('2019-07-01')) {
                $scope.pageData.showHistoricalActivity = true;
            }
        }
    });

    $scope.$watch(function() { return User.getMilestones(); }, function(milestones) {
        if (milestones) {
            $scope.milestones = milestones;

            if (!$scope.filters.data.milestones) $scope.filters.data.milestones = {};
            angular.forEach(milestones, function(ms) {
                $scope.filters.data.milestones[ms.id] = false;
            });
        }
    });


    $scope.toggleFilters = function() {
        $scope.pageData.showFilters = !$scope.pageData.showFilters;
    };

    $scope.resetFilter = function(name) {
        switch (name) {
            case 'date':
                $scope.filters.data.date = {
                    startDate: null,
                    endDate: null,
                };
                break;
            case 'type':
                $scope.filters.data.type = null;
                break;
            case 'milestones':
            /* falls through */
            case 'accounts':
                angular.forEach($scope.filters.data[name], function(value, key) {
                    $scope.filters.data[name][key] = false;
                });
                break;
        }
    };


}]);
